import React, { ReactElement } from 'react';
import { ILiveFavoriteCategory } from '../../models/LiveCategory';
import './CategoryName.scss';
export interface CategoryNameProps {
  category: ILiveFavoriteCategory | undefined;
}

export const CategoryName = (props: CategoryNameProps): ReactElement => {
  return (
    <div
      className="favorite-category-name"
      style={{ backgroundColor: props.category?.liveCategory.color }}
    >
      {props.category?.liveCategory.name}
    </div>
  );
};
